import React, { Component } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import _ from 'lodash';

class revokedDiscountProducts extends Component {
    render() {
        const { isModalOpen, revokedDiscountProducts, handleRevokedProductsSubmit, responseMessage } = this.props;
        const groupByCategory = _.groupBy(revokedDiscountProducts, 'category_name');
        return (
            <>
                <Modal
                    backdrop="static"
                    keyboard={false}
                    isOpen={isModalOpen}
                    className="modal-dialog-centered modal-lg"
                >
                    <ModalHeader className=" bg-primary">{responseMessage}</ModalHeader>
                    <ModalBody>
                        Update: The offer applied to certain products in your cart has been withdrawn or expired. We
                        apologize for any inconvenience caused. Below, you will find a list of products by their
                        category.
                        <br />
                        {
                            <>
                                {Object.entries(groupByCategory).map(([category, products], index) => (
                                    <div key={category}>
                                        {products[0].discount_type === '3' && <p>{index + 1}. Free {products[0].free_cartons} carton(s) from {category} Category</p>}
                                        {products[0].discount_type === '2' && (
                                            <p>
                                                {index + 1}. Free {products[0].get} carton(s) from {category} Category
                                            </p>
                                        )} 
                                         {products[0].discount_type === '1' && ( <p>
                                             {index + 1}. {products[0].discount_type_name}{' '}
                                             {products[0].discount_percentage}% off from {category} Category.
                                         </p>)}
                                        
                                        <ul>
                                            {products.map((product, index) => (
                                                <li key={index}>{product.product_name}</li>
                                            ))}
                                        </ul>
                                    </div>
                                ))}
                            </>
                        }
                        If you have any concerns or require further clarifications, please reach out to our customer
                        support.
                    </ModalBody>
                    <ModalFooter
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                        }}
                    >
                        <Button color="primary" onClick={handleRevokedProductsSubmit}>
                            OK
                        </Button>
                    </ModalFooter>
                </Modal>
            </>
        );
    }
}

export default revokedDiscountProducts;

/**

 */
